var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImportJobsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.63229 0.632812V9.03359M10.4326 6.23333L7.63229 9.03359L4.83203 6.23333",
    stroke: "#4C6484",
    strokeWidth: 1.26012,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83125 2.03125H2.03099C1.65965 2.03125 1.30352 2.17876 1.04095 2.44134C0.778373 2.70391 0.630859 3.06004 0.630859 3.43138V10.432C0.630859 10.8034 0.778373 11.1595 1.04095 11.4221C1.30352 11.6846 1.65965 11.8322 2.03099 11.8322H13.232C13.6034 11.8322 13.9595 11.6846 14.2221 11.4221C14.4846 11.1595 14.6322 10.8034 14.6322 10.432V3.43138C14.6322 3.06004 14.4846 2.70391 14.2221 2.44134C13.9595 2.17876 13.6034 2.03125 13.232 2.03125H10.4318",
    stroke: "#4C6484",
    strokeWidth: 1.26012,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportJobsIcon);
export default __webpack_public_path__ + "static/media/import-jobs-icon.c9ce616404dd42e1700f19708eae051d.svg";
export { ForwardRef as ReactComponent };